import React from 'react';
import ShowSlider      from './modules/ShowSlider';
import OpinionSlider   from './modules/OpinionSlider';
import PerformanceHero from './modules/PerformanceHero';
import PhotoGallery    from './modules/PhotoGallery';
import CastList        from './modules/CastList';
import RichText        from './modules/RichText';
import PlatformCards   from './modules/PlatformCards';
import ComingSoonList  from './modules/ComingSoonList';
import VideoEmbed      from './modules/VideoEmbed';
import TribuneItem     from './modules/TribuneItem';

// Dispatches each module object from Sanity to the correct React component.
// New module types can be added here without touching any other file.
export default function ModuleRenderer({ module: mod }) {
  if (!mod || !mod._type) return null;

  switch (mod._type) {
    case 'moduleShowSlider':
      return (
        <ShowSlider
          heading={mod.heading}
          slidesToShow={mod.slidesToShow}
          autoplaySpeed={mod.autoplaySpeed}
          filterSection={mod.filterSection}
        />
      );

    case 'moduleOpinionSlider':
      return (
        <OpinionSlider
          heading={mod.heading}
          slidesToShow={mod.slidesToShow}
          autoplaySpeed={mod.autoplaySpeed}
          filterByShow={mod.filterByShow}
        />
      );

    case 'modulePerformanceHero':
      return <PerformanceHero performance={mod.performance} />;

    case 'modulePhotoGallery':
      return (
        <PhotoGallery
          source={mod.source}
          performance={mod.performance}
          photos={mod.photos || []}
          photoCredit={mod.photoCredit}
        />
      );

    case 'moduleCastList':
      return <CastList heading={mod.heading} castText={mod.castText} />;

    case 'moduleRichText':
      return <RichText heading={mod.heading} body={mod.body} />;

    case 'modulePlatformCards':
      return (
        <PlatformCards
          heading={mod.heading}
          description={mod.description}
          slidesToShow={mod.slidesToShow}
          autoplaySpeed={mod.autoplaySpeed}
        />
      );

    case 'moduleComingSoonList':
      return <ComingSoonList heading={mod.heading} items={mod.items} />;

    case 'moduleVideo':
      return (
        <VideoEmbed
          heading={mod.heading}
          videoUrl={mod.videoUrl}
          caption={mod.caption}
        />
      );

    case 'moduleTribuneItem':
      return (
        <TribuneItem
          heading={mod.heading}
          body={mod.body}
          image={mod.image}
          linkUrl={mod.linkUrl}
          linkLabel={mod.linkLabel}
        />
      );

    default:
      console.warn('[ModuleRenderer] Unknown module type:', mod._type);
      return null;
  }
}
